import { c as _c } from "react/compiler-runtime";
/**
 * Skeleton loader for GrowthPreviewCard
 *
 * Displayed while the main component loads (dynamic import with ssr: false).
 * Dimensions match the actual component to prevent layout shift.
 */
export function GrowthPreviewCardSkeleton() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="px-[15px] pb-[10px]"><div className="h-11 w-full rounded-[14px] bg-gray-200" /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="flex justify-center px-[15px] pb-[8px]"><div className="h-5 w-28 rounded bg-gray-200" /></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-[86px] w-[86px] rounded-full bg-gray-200" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-4 w-24 rounded bg-gray-200" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="grid grid-cols-[auto_1fr] gap-x-[15px] px-[15px]">{t2}<div className="flex flex-col justify-center space-y-3">{t3}<div className="flex justify-between"><div className="h-10 w-12 rounded bg-gray-100" /><div className="h-10 w-16 rounded bg-gray-100" /><div className="h-10 w-14 rounded bg-gray-100" /></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="mt-[10px] space-y-2 px-[15px]"><div className="h-4 w-full rounded bg-gray-100" /><div className="h-4 w-2/3 rounded bg-gray-100" /></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="mt-[12px] grid grid-cols-[1fr_1fr_34px] gap-x-[6px] px-[15px]"><div className="h-[34px] rounded-lg bg-blue-100" /><div className="h-[34px] rounded-lg bg-gray-100" /><div className="h-[34px] w-[34px] rounded-lg bg-gray-100" /></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-full w-full animate-pulse overflow-hidden bg-white pt-4">{t0}{t1}{t4}{t5}{t6}<section className="mt-[10px] grid grid-cols-4 border-t border-gray-100 pt-2"><div className="mx-auto h-6 w-6 rounded bg-gray-100" /><div className="mx-auto h-6 w-6 rounded bg-gray-100" /><div className="mx-auto h-6 w-6 rounded bg-gray-100" /><div className="mx-auto h-6 w-6 rounded bg-gray-100" /></section></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}